import type { StreamingBlock } from "@storytell/streaming";
import { TbRefresh } from "solid-icons/tb";
import { Show, createMemo } from "solid-js";

interface RetryRendererProps {
  block: StreamingBlock;
}

export const RetryRenderer = (props: RetryRendererProps) => {
  const retryMessage = createMemo(() => {
    const content = props.block.finalContent;
    if (content?.type === "retry") {
      return content.message;
    }
    return null;
  });

  return (
    <Show when={retryMessage()}>
      {(message) => (
        <div class="px-4 py-3 rounded-lg bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800/30 mb-4">
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <TbRefresh
                size={20}
                class="text-yellow-600 dark:text-yellow-500 animate-spin"
                style={{ "animation-duration": "2s" }}
              />
            </div>

            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-medium text-yellow-800 dark:text-yellow-300 mb-1">Refining results...</h4>

              <p class="text-sm text-yellow-700 dark:text-yellow-400">{message()}</p>
            </div>
          </div>
        </div>
      )}
    </Show>
  );
};
